import React, { useState } from 'react';
import { Tooltip } from '@mui/material';

export const CustomTooltip = ({
  text,
  position = 'top',
  fontSize = 12,
  justClick = false,
  children,
  duration = 2000,
}) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    if (justClick) {
      setOpen(true);
      setTimeout(() => setOpen(false), duration);
    }
  };

  if (justClick) {
    return (
      <Tooltip
        arrow
        title={text}
        placement={position}
        open={open}
        onClose={() => setOpen(false)}
        disableHoverListener
        disableFocusListener
        disableTouchListener
        PopperProps={{
          disablePortal: true,
          sx: {
            '& .MuiTooltip-tooltip': {
              fontSize,
              padding: 1.5,
            },
          },
        }}
      >
        <span onClick={handleClick} style={{ cursor: 'pointer' }}>
          {children}
        </span>
      </Tooltip>
    );
  }

  return (
    <Tooltip
      arrow
      title={text}
      placement={position}
      PopperProps={{
        sx: {
          '& .MuiTooltip-tooltip': {
            fontSize,
            padding: 1.5,
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};
